<template>
<div class="animated fadeIn">
    <div class="row">
        <div class="col-sm-12">
            <b-card>
                <div slot="header">
                    <strong>{{$t('ARTICLE')}}</strong>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('MODULARTEMPLATE')">
                            <b-form-select :options="modularTemplates.root" v-model="formData.templateId" value-field="templateId" text-field="name"></b-form-select>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('CATEGORY')">
                            <b-form-select :options="categories.root" v-model="formData.categoryId" value-field="categoryId" text-field="categoryName"></b-form-select>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('NAME')+' '+$t('OPTIONAL')">
                            <b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('HEADER')">
                            <b-form-input type="text" v-model="formData.header" v-bind:placeholder="$t('HEADER')"></b-form-input>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('DATETIME')">
                            <datepicker v-model="formData.dateTime" name="dateTime"></datepicker>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('LANGUAGE')">
                            <b-form-select :options="languages.root" v-model="formData.langId" value-field="langId" text-field="langName"></b-form-select>
                        </b-form-fieldset>
                    </div>
                </div>
                <div v-if="standardData">
                    <wysiwyg v-model="formData.content" />
                </div>
                <div v-if="!standardData">
                    <div class="row" v-for="(module, key) in modularData" :key="key">
                        <div class="col-sm-12" v-if="module.type == 'textfield'">
                            <b-form-fieldset v-bind:label="module.title">
                                <b-form-input type="text" v-model="formData.modularData[module.name]" v-bind:placeholder="module.title"></b-form-input>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-12" v-if="module.type == 'linkfield'">
                            <b-form-fieldset v-bind:label="$t('LINK')">
                                <b-form-input type="text" v-model="formData.modularData[module.nametext]" v-bind:placeholder="$t('LINKTEXT')"></b-form-input><br>
                                <b-form-input type="text" v-model="formData.modularData[module.namelink]" v-bind:placeholder="$t('LINK')"></b-form-input><br>
                                <b-form-input type="text" v-model="formData.modularData[module.namealt]" v-bind:placeholder="$t('ALT')"></b-form-input><br>
                                <b-form-checkbox :plain="true" v-model="formData.modularData[module.namecheck]" value="1">{{$t('BLANK')}}</b-form-checkbox>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-12" v-if="module.type == 'imagescat'">
                            <b-form-fieldset v-bind:label="module.title">
                                <b-form-select :options="module.repeatoptions" v-model="formData.modularData[module.name]" value-field="categoryId" text-field="categoryName"></b-form-select>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-12" v-if="module.type == 'textarea'">
                            <b-form-fieldset v-bind:label="module.title">
                                <b-form-textarea v-model="formData.modularData[module.name]" v-bind:placeholder="module.title"></b-form-textarea>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-12" v-if="module.type == 'wysiwyg'">
                            <b-form-fieldset v-bind:label="module.title">
                                <wysiwyg v-model="formData.modularData[module.name]" />
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-12" v-if="module.type == 'fileupload'">
                            <b-form-fieldset v-bind:label="module.title">
                                <b-form-input type="text" v-model="formData.modularData[module.name]" v-bind:placeholder="module.title" :imageType="module.imagetype"></b-form-input>
                            </b-form-fieldset>
                        </div>
                        <div class="col-sm-12" v-if="module.type == 'imgupload'">
                            <b-form-fieldset v-bind:label="module.title">
                                <b-form-input type="text" v-model="formData.modularData[module.name]" v-bind:placeholder="module.title" :imageType="module.imagetype"></b-form-input>
                            </b-form-fieldset>
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
                    <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(formData)"><icon icon="dot-circle"></icon> {{$t('SUBMIT')}}</b-button>
                </div>
            </b-card>
        </div>
    </div>
</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import ApiTemplates from '@/api/admin/WikiTemplates'
import ApiCats from '@/api/admin/WikiCategory'
import Api from '@/api/admin/Wiki'
import ApiLang from '@/api/admin/TransLang'

export default {
  name: 'WikiTemplates',
  data: function()
  {
    return {
      data: {},
      formError: {},
      formData:
      {
        name: '',
        content: '',
        categoryId: '',
        templateId: '',
        modularData: {}
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      },
      categories: {},
      modularTemplates: {},
      languages: {},
      modularData: []
    }
  },
  created: function()
  {
    var me = this;

    me.getData();
    me.getCatsData();
    me.getTemplateData();
    me.getLanguagesData();
  },
  methods:
  {
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.wikiId != 'undefined')
      {
        item.id = item.wikiId;
        delete(item.wikiId);
      }

      Api.save(item, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
        }
      })
    },
    getData: function()
    {
      var me = this;
      if(me.$route.params.wikiId)
      {
            Api.getSingleWiki({wikiId: me.$route.params.wikiId}, function(data)
            {
                if(data.error && data.error == true)
                {
                    me.$notify.notice(data);
                    return;
                }
                me.formData = data.data;
            });
      }
    },
    getCatsData: function()
    {
      var me = this;
      ApiCats.selectRow({start: 0, limit: 100}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.categories = data;
      });
    },
    getTemplateData: function()
    {
      var me = this;
      ApiTemplates.selectRow({start: 0, limit: 100}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.modularTemplates = data;
      });
    },
    getLanguagesData: function()
    {
      var me = this;
      ApiLang.selectRow({start: 0, limit: 100}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.languages = data;
      });
    }
  },
  watch:
  {
      'formData.templateId'(val)
      {
          var me = this;
          Api.getWikiModules({templateId: val}, function(data)
        {
            if(data.error && data.error == true)
            {
                me.$notify.notice(data);
                return;
            }
            me.modularData = data.data;
        });
      }
  },
  computed:
  {
      standardData()
      {
          var me = this;

          if(!me.formData.templateId || me.formData.templateId == '')
          {
              return true;
          }
          return false;
      }
  }
}
</script>
